module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/facebook_login-7692d6c379288885d619b1e80bb214a4.png";